module.exports = __webpack_public_path__ + "img/patreon.128d9789.svg";